import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";
import axios from "axios";
import {BASE_URL} from "../contants/network";

export const processFlashyCsv = async (domain: string, fileKey: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'shop/flashy-list',
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: { fileKey },
        domain
    });
}